<template>
  <div class="right_box_main">
    <!-- 面包屑导航 -->
   
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                <el-form-item label="咨询事务名称:" style="margin:0 10 0 0;">
                  <el-input
                    v-model="searchlist.advisoryName"
                    placeholder="请输入"
                    style="width:200px"
                  ></el-input>
                </el-form-item>
                <el-form-item label="政策类别:" style="margin:0 30 0 0;">
                  <el-select
                    v-model="searchlist.policyConsultationTypeId"
                    placeholder="--请选择--"
                    style="width:150px"
                  >
                    <el-option
                      v-for="item in Types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="发布日期:" style="margin:0 30 0 0;">
                  <el-date-picker
                    v-model="queryTime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="状态:" style="margin:0 30 0 0;">
                  <el-radio-group v-model="searchlist.status">
                    <el-radio label="0">启用</el-radio>
                    <el-radio label="1">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="three">
              <el-button
                type="primary"
                size="mini"
                @click="showDialogForm('','add')"
              >新增</el-button>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
              >
                <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >-->
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                <el-table-column align="center" prop="advisoryName" label="咨询事务名称"></el-table-column>
                <el-table-column
                  align="center"
                  prop="policyConsultationTypeName"
                  label="政策类别"
                  width="160px"
                ></el-table-column>
                <el-table-column align="center" prop="releaseDate" label="发布时间" width="180px"></el-table-column>
                <el-table-column align="center" prop="approvalStatus" label="审批状态" width="100px">
                  <template scope="scope">
                    <span
                      class="tab"
                      :class="{ active_tab2: scope.row.approvalStatus == '1',active_tab1:scope.row.approvalStatus=='0',active_tab:scope.row.approvalStatus=='2'}"
                    >{{ scope.row.approvalStatus == '1'?'通过':(scope.row.approvalStatus == '2'?'不通过':'待审批') }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="status" label="状态" width="100px">
                  <template scope="scope">
                    <el-switch
                      v-permission="{sign:'yzsbl:zczx:ztxg'}"
                      v-model="scope.row.status"
                      active-value="0"
                      inactive-value="1"
                      @change="changeStatus(scope.row)"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="230" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip
                      v-if="scope.row.approvalStatus!='1'"
                      class="item"
                      effect="light"
                      content="编辑"
                      placement="top-start"
                    >
                      <button
                        class="iconfont icon-bianji3 tabBtn"
                        @click="showDialogForm(scope.row.id,'edit')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      v-if="scope.row.approvalStatus == '0'"
                      class="item"
                      effect="light"
                      content="审批"
                      placement="top-start"
                      style="fontWeight:bold"
                    >
                      <button
                        class="iconfont icon-shenhe tabBtn"
                        @click="showDialogForm(scope.row.id,'audit')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      v-if="scope.row.approvalStatus == '0'"
                      class="item"
                      effect="light"
                      content="删除"
                      placement="top-start"
                    >
                      <button
                        class="iconfont icon-icon7 tabBtn"
                        @click="showdeletepanduan(scope.row.id)"
                      ></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                      <button
                        class="iconfont icon-chakan tabBtn"
                        @click="showDialogForm(scope.row.id,'detail')"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageConfig.pageSize"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showadd"
      width="1100px"
      :before-close="clearadddata"
    >
      <el-form ref="addform" :rules="rules" :model="addform" label-width="110px" size="mini">
        <el-form-item label="政策类别:" prop="policyConsultationTypeId">
          <el-select
            :disabled="editDisable"
            v-model="addform.policyConsultationTypeId"
            placeholder="--请选择--"
            style="width:50%"
          >
            <el-option
              v-for="item in Types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="咨询标题：" prop="advisoryName">
          <el-input
            :disabled="editDisable"
            v-model="addform.advisoryName"
            placeholder="请输入"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content" style="margin-top: 10px;margin-bottom: 120px">
          <quillEditor
            :disabled="editDisable"
            v-model="addform.content"
            :options="editorOption"
            style="height:150px"
          ></quillEditor>
        </el-form-item>
        <el-form-item label="发布时间:" prop="releaseDate">
          <el-date-picker
            :disabled="editDisable"
            v-model="addform.releaseDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="mini"
            style="width:50%"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上传附件：" prop="enclosure">
          <el-upload
            :disabled="editDisable"
            :limit="3"
            :on-exceed="handleExceed"
            :on-success="uploadSuccess"
            :file-list="fileList"
            :action="uploadUrl"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <span slot="tip" class="el-upload__tip">&nbsp;&nbsp;&nbsp;附件大小不超过2M</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-radio-group :disabled="editDisable" v-model="addform.status">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showApprove" label="审批结果: ">
          <el-radio-group :disabled="approveDisable" v-model="addform.approvalStatus">
            <el-radio label="1">通过</el-radio>
            <el-radio label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showApprove" label="审批意见: ">
          <el-input
            :disabled="approveDisable"
            type="textarea"
            style="width:50%"
            :rows="4"
            placeholder="请输入内容"
            v-model="addform.approvalOpinion"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          v-if="showSaveBtn"
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="saveadddata"
        >保存</el-button>
        <el-button type="info" size="small" @click="clearadddata">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from "../../../utils/editorOption.js";
import request from "../../../utils/request.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  components: { quillEditor },
  data() {
    return {
      dialogTitle: "新增",
      // 新增弹出层
      flag: "add",
      showadd: false,
      editDisable: false,
      approveDisable: false,
      showApprove: false,
      showSaveBtn: true,
      addform: {},
      Types: [],
      fileList: [],
      uploadUrl: request.defaults.baseURL + "/oneStopUpload/info/uplodfiles",
      // 富文本配置
      editorOption: editor_option.editorOption,
      rules: {
        policyConsultationType: [
          { required: true, message: "请选择咨询类别", trigger: "blur" }
        ],
        advisoryName: [
          { required: true, message: "请输入咨询标题", trigger: "blur" }
        ],
        content: [
          { required: true, message: "请输入咨询内容", trigger: "blur" }
        ],
        releaseDate: [
          { required: true, message: "请选择发布时间", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择发布状态", trigger: "blur" }]
      },
      // 查询
      queryTime: [],
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      status: true
    };
  },
  methods: {
    //条件查询
    searchlistdata() {
      this.pageConfig = {
        pageSize: 10,
        pageNo: 1
      };
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchlist = {};
      this.pageConfig = {
        pageSize: 10,
        total: 0,
        pageNo: 1
      };
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      if (this.queryTime.length > 0) {
        this.searchlist.startTime = this.queryTime[0];
        this.searchlist.overTime = this.queryTime[1];
      }
      var res = await request({
        url: "/policyConsultation/info/listPolicyConsultation",
        method: "POST",
        data: {
          ...this.searchlist,
          ...this.pageConfig
        }
      });
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      } else {
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    //改变状态
    async changeStatus(cdata) {
      var res = await request({
        url: "/policyConsultation/info/updatePolicyConsultation",
        method: "POST",
        data: { ...cdata }
      });
      var msg = "状态";
      msg = msg + (cdata.status == "0" ? "启用" : "禁用");
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success"
        });
      } else {
        this.$message({
          message: msg + "失败：" + res.message,
          type: "error"
        });
      }
    },
    async showDialogForm(id, flag) {
      this.flag = flag;
      if (id != "") {
        if (flag == "edit") {
          this.editDisable = false;
          this.showApprove = false;
          this.approveDisable = true;
          this.showSaveBtn = true;
          this.dialogTitle = "编辑";
        } else if (flag == "audit") {
          this.editDisable = true;
          this.showApprove = true;
          this.approveDisable = false;
          this.showSaveBtn = true;
          this.dialogTitle = "审批";
        } else if (flag == "detail") {
          this.editDisable = true;
          this.showApprove = false;
          this.approveDisable = true;
          this.showSaveBtn = false;
          this.dialogTitle = "查看";
        }

        //获取编辑项的最新数据
        let data = {};
        data.id = id;
        var res = await request({
          url: "/policyConsultation/info/getPolicyConsultation",
          method: "POST",
          data: data
        });
        if (res.code == 200) {
          this.addform = res.content;
          this.showadd = true;
          //上传数组显示
          this.fileList = [];
          var temp = {};
          //判断审批状态
          if (res.content.approvalStatus == 2) {
            this.status = false;
          } else {
            this.status = true;
          }
          if (
            res.content.enclosurePath != null &&
            res.content.enclosurePath != ""
          ) {
            var namesArr = JSON.parse(res.content.enclosureName);
            var enclosureArr = JSON.parse(res.content.enclosurePath);
            enclosureArr.forEach((item, index) => {
              if (item != "") {
                temp = {
                  name: namesArr[index] ? namesArr[index] : "附件" + index,
                  url: item
                };
                this.fileList.push(temp);
              }
            });
          }
        } else {
          this.$message({
            message: "数据项加载异常",
            type: "error"
          });
          this.showadd = false;
        }
      } else {
        this.editDisable = false;
        this.showApprove = false;
        this.approveDisable = true;
        this.showSaveBtn = true;
        this.showadd = true;
        this.dialogTitle = "新增";
        this.addform = {};
        this.fileList = [];
      }
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.fileList.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    //获取新增所有数据发请求
    async saveadddata() {
      if (this.fileList.length > 0) {
        this.addform.enclosurePath = "";
        this.addform.enclosureName = "";
        this.fileList.forEach(item => {
          this.addform.enclosurePath = item.url;
          this.addform.enclosureName = item.name;
        });
      }
      if (!this.status) {
        this.addform.approvalStatus = "0";
      }
      let url = "/policyConsultation/info/updatePolicyConsultation";
      if (this.flag == "add") {
        url = "/policyConsultation/info/insertPolicyConsultation";
      }

      var res = await request({
        url: url,
        method: "POST",
        data: {
          ...this.addform
        }
      });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success"
        });
        this.showadd = false;
        this.getPageDatas();
      } else {
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error"
        });
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false;
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let data = {};
          data.id = id;
          var res = await request({
            url: "/policyConsultation/info/deletePolicyConsultation",
            method: "POST",
            data: data
          });
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.showadd = false;
            this.getPageDatas();
          } else {
            this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getlbList() {}
  },
  mounted() {
    this.getPageDatas();
    // 初始化数据
    this.Types = [
      { label: "民政救助", value: 1 },
      { label: "退役军人服务", value: 2 },
      { label: "人社保障", value: 3 },
      { label: "残疾人保障", value: 4 },
      { label: "卫生健康", value: 5 },
      { label: "公租房申请", value: 6 },
      { label: "社区建设", value: 7 },
      { label: "医疗保障", value: 8 },
      { label: "宗教事务", value: 9 },
      { label: "其它", value: 99 }
    ];
  }
};
</script>

<style lang="less" scoped>
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
</style>